import { SvgIconProps } from "@mui/material"
import Image from "next/image"
import React, { AriaAttributes, AriaRole, FC } from "react"

import { ReactComponent as profile } from "src/assets/icons/adfva-1.svg"
import { ReactComponent as barsSvg } from "src/assets/icons/bars.svg"
import { ReactComponent as cartBatch } from "src/assets/icons/cart-batch.svg"
import { ReactComponent as cart } from "src/assets/icons/cart.svg"
import { ReactComponent as circleArrowRight } from "src/assets/icons/circleArrowRight.svg"
import { ReactComponent as orders } from "src/assets/icons/gbada.svg"
import { ReactComponent as logout } from "src/assets/icons/Gruppe 379.svg"
import { ReactComponent as home } from "src/assets/icons/home-white.svg"
import { ReactComponent as contactPerson } from "src/assets/icons/Kontaktverwaltung.svg"
import { ReactComponent as account } from "src/assets/icons/mein-konto-white.svg"
import { ReactComponent as language } from "src/assets/icons/sprache-white.svg"
import { ReactComponent as bookingWhite } from "src/assets/icons/standbuchung-white.svg"
import { ReactComponent as bookingsYellow } from "src/assets/icons/standbuchung-yellow.svg"
import { ReactComponent as store } from "src/assets/icons/store-white.svg"
import { ReactComponent as service } from "src/assets/icons/wrvRS.svg"
import { ReactComponent as xmark } from "src/assets/icons/xmark.svg"

const iconsMap = {
  bars: barsSvg,
  circleArrowRight: circleArrowRight,
  x: xmark,
  profile: profile,
  orders: orders,
  bookings: bookingWhite,
  bookingsYellow: bookingsYellow,
  service: service,
  home: home,
  store: store,
  account: account,
  language: language,
  cart: cart,
  cartBatch: cartBatch,
  logout: logout,
  contactPerson: contactPerson,
} as const

export type IconName = keyof typeof iconsMap

export type IconProps = {
  name?: IconName
  className?: string
  role?: AriaRole
} & AriaAttributes

export const Icon: FC<IconProps> = ({ name, ...props }) => {
  if (name === undefined) {
    return null
  }
  const Component = iconsMap[name]
  return <Component aria-hidden="true" role="presentation" {...props} />
}

export const HomeIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="home" {...(props as any)} />
)

export const BookingYellow: React.FC<SvgIconProps> = (props) => (
  <Icon name="bookingsYellow" {...(props as any)} />
)

export const BookingWhite: React.FC<SvgIconProps> = (props) => (
  <Icon name="bookings" {...(props as any)} />
)

export const ArrowRight: React.FC<SvgIconProps> = (props) => (
  <Icon name="circleArrowRight" {...(props as any)} />
)

export const StoreIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="store" {...(props as any)} />
)

export const AccountIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="account" {...(props as any)} />
)

export const LanguageIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="language" {...(props as any)} />
)

export const CartIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="cart" {...(props as any)} />
)

export const CartBatchIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="cartBatch" {...(props as any)} />
)

export const LogoutIcon: React.FC<SvgIconProps> = (props) => (
  <Icon name="logout" {...(props as any)} />
)

export const ContactPerson: React.FC<SvgIconProps> = (props) => (
  <Icon name="contactPerson" {...(props as any)} />
)

export const DefaultProductImg: React.FC<SvgIconProps> = (props) => (
  // <Icon name="contactPerson" {...(props as any)} />
  <Image alt={""} src={"src/assets/icons/MB-logo_vertical_blue.png"} />
)
